import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Notifications_ds_auto_email_rule_reportsService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { ruleId?: string, $top?: number, $skip?: number }): Promise<{ result?: { id?: string, type?: string, name?: string, options?: string, rule_id?: string }[], totalCount?: number }> {

    let url = `${environment.backendUrl}api/Notifications/datasources/ds_auto_email_rule_reports/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { ruleId?: string, $keys: string[] }): Promise<{ result?: { id?: string, type?: string, name?: string, options?: string, rule_id?: string }[] }> {

    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Notifications/datasources/ds_auto_email_rule_reports/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
}
